/**
 * Authorization utility functions
 */

/**
 * Check if the current user is a guest
 * @param {Object} user - The user object from AuthContext
 * @returns {boolean} True if the user is a guest, false otherwise
 */
export const isGuestUser = (user) => {
  return user && user.isGuest === true;
};

/**
 * Check if the current user is an admin
 * @param {Object} user - The user object from AuthContext
 * @returns {boolean} True if the user is an admin, false otherwise
 */
export const isAdminUser = (user) => {
  return user && user.isAdmin === true;
};

/**
 * Check if the current user can perform edits (not a guest)
 * @param {Object} user - The user object from AuthContext
 * @returns {boolean} True if the user can edit, false otherwise
 */
export const canUserEdit = (user) => {
  return user && user.isGuest !== true;
}; 